/** Fuel heat gradient: 0=burned, 1=cool blue, 2=teal, 3=amber, 4=hot red */
const FUEL_COLORS = [
  "#1e293b", // 0 — burned out (dark slate)
  "#0ea5e9", // 1 — sky blue
  "#14b8a6", // 2 — teal
  "#f59e0b", // 3 — amber
  "#ef4444", // 4 — red
];

export function fuelColor(fuel: number): string {
  return FUEL_COLORS[Math.min(fuel, FUEL_COLORS.length - 1)] ?? FUEL_COLORS[0]!;
}

export function fuelTextColor(fuel: number): string {
  if (fuel === 0) return "#475569"; // dim for burned out
  return "#ffffff";
}

export const PLAYER_COLOR = "#f97316"; // orange-500
export const PLAYER_GLOW = "rgba(249, 115, 22, 0.4)";
export const VALID_MOVE_COLOR = "rgba(249, 115, 22, 0.25)";
export const GRID_LINE_COLOR = "#334155"; // slate-700
export const BURNED_PATTERN_COLOR = "#0f172a"; // slate-900
